/**
 * @file 局部编辑
 */ import {useCallback, useEffect, useRef} from "react";
import type {IEditor} from "@baidu/code-live-core";
import {IframeBridge} from "@baidu/code-live-utils";

export const useEditor = (
    editor: IEditor,
) => {
    const editorRef = useRef(editor);
    editorRef.current = editor;
    
    const editorSetup = useCallback((bridge: IframeBridge) => {
        bridge.on('editor-undo', () => {
            const editor = editorRef.current;
            if (typeof editor.undo === 'function') {
                editor.undo();
            }
        });
        bridge.on('editor-redo', () => {
            const editor = editorRef.current;
            if (typeof editor.redo === 'function') {
                editor.redo();
            }
        });
        bridge.registerApi('editor-onchange', (data: {op}) => {
            const editor = editorRef.current;
            if (typeof editor.onChange === 'function') {
                return editor.onChange(data.op);
            }
        });
        bridge.on('editor-onrange-trigger', (data: {prompt: string, options: {
            tagName: string,
            range: {
                start: [number, number];
                end: [number, number];
            }
        }}) => {
            const editor = editorRef.current;
            if (typeof editor.onRangeTrigger === 'function') {
                editor.onRangeTrigger(data.prompt, data.options);
            }
        });
        bridge.on('editor-select-change', () => {
            const editor = editorRef.current;
            if (typeof editor.onFocusChange === 'function') {
                editor.onFocusChange();
            }
        });
    }, []);
    
    return {
        editorSetup,
    }
}
